import { createFileRoute } from '@tanstack/react-router';
import {
  analyticsLoaderDeps,
  storeReportQueryOptions,
  StoreReportPage,
} from '@/features/analytics';
import i18n from '@/lib/i18n';
import { useAuthStore } from '@/stores/auth';

export const Route = createFileRoute('/_authed/analytics/store-report')({
  loaderDeps: ({ search }) => analyticsLoaderDeps(search),
  loader: ({ context, deps }) => {
    const activeBranchId = useAuthStore.getState().activeBranchId;
    const branchId = activeBranchId && activeBranchId !== 'all' ? activeBranchId : undefined;
    const lang = i18n.language.startsWith('tl') || i18n.language.startsWith('fil') ? 'fil' : 'en';

    void context.queryClient.prefetchQuery(
      storeReportQueryOptions({
        period: deps.period,
        branch_id: branchId,
        lang,
      }),
    );
  },
  component: StoreReportPage,
});
